import { useEffect, useRef } from 'react';

interface IUseTrackOnceOptions {
  trackFn: Function;
  shouldTrack?: boolean;
  deps?: unknown[];
}

export function useTrackOnce({
  trackFn,
  shouldTrack = true,
  deps = [],
}: IUseTrackOnceOptions) {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current || !shouldTrack) return;

    trackFn();
    hasTrackedRef.current = true;
  }, [shouldTrack, ...deps]);
}
